import { catchWheelEvent } from "@common/utils/utils";

const sideBar1_Init = () => {
  $(`aside[class*='sideBar-'].type_1 .sideBar-1-backdrop`).on("click", () => {
    $(`aside[class*='sideBar-'].type_1`).removeClass("sideBar__open");
    catchWheelEvent(false);
  });
  $(`aside[class*='sideBar-'].type_1 .handleSwitch`).on("click", () => {
    $(`aside[class*='sideBar-'].type_1`).toggleClass("sideBar__open");
    if ($(`aside[class*='sideBar-'].type_1`).hasClass("sideBar__open")) {
      catchWheelEvent(false);
    } else {
      catchWheelEvent(false);
    }
  });
  $(`aside[class*='sideBar-'].type_1 .triangle`).on("click", function () {
    const isHide = $(this).parent().siblings("ul").is(":hidden");
    $(this)
      .parent()
      .siblings("ul")
      .slideToggle({
        duration: 300,
        start: () => {
          if (isHide) {
            $(this).parent().addClass("active");
          } else {
            $(this).parent().removeClass("active");
          }
        },
      });
  });
};

export default sideBar1_Init;
